export default "__VITE_ASSET__DkTJt$LI__"